import { configureOfflineMaps, isConfigured } from '@onxmaps/x-offline-maps'
import type { ErrorContext } from '@onxmaps/x-offline-maps'
import httpClient from '@/lib/http-client'
import { initializeOfflineMapServiceInstance } from '@/services/offline-map-service/offline-map-service-instance'
import { captureException } from '@sentry/vue'

/**
 * Initialize the x-offline-maps package with configuration derived from the
 * current application environment.
 *
 * @returns true if initialization succeeded, false if already configured
 */
export const initializeXOfflineMaps = (): boolean => {
  if (isConfigured()) {
    return false
  }

  configureOfflineMaps({
    tilestoreUrl: window.environment.tilestoreUrl,
    httpClient,
    deviceId: 'default',
    basemap: 'vector',
    unitType: 'imperial',
    onError: (error: Error, context: ErrorContext) => {
      captureException(error, {
        tags: {
          feature: context.feature,
          action: context.action,
        },
        extra: context.metadata,
      })
    },
  })

  return true
}

/**
 * Initializes the x-offline-maps package and the offline map service instance.
 * Call early in the app lifecycle from each map page.
 *
 * @returns true if the package was initialized, false if already configured
 */
export const initializeXOfflineMapsWhenEnabled = (): boolean => {
  const configured = initializeXOfflineMaps()
  initializeOfflineMapServiceInstance()
  return configured
}
